import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from 'react-router';
import { compose } from "redux";
import {
  Button,
  Row,
  FormGroup,
  InputGroup,
  FormControl,
  MenuItem,
  Alert,
  ButtonGroup,
  DropdownButton,
  Glyphicon
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from '../../../components';
import { listPostup } from '../../../redux/actions/postupActions';
import Pagination from "react-paginating";
import { connect } from "react-redux";
import isEmpty from "lodash.isempty";
import {
  renderAlert,
  clearAlert
} from "../../../redux/actions/alertsActions";
import {aclUtil} from "../../util";
import { createBrowserHistory } from "history";

const history = createBrowserHistory();

let isLoading = "false";
const listUrl = 'postup-list/list'

class List extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
    	path: ["Home", "Manage Postup"],
      links: ["home", "postup/list"],
      menuKey: 'LIST_POSTUP',
      list: [],
      totalRecords: 0,
      limit: 25,
      search: "",
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "success",
      legal_nameSortIcon: "glyphicon glyphicon-sort-by-attributes",
      account_nameSortIcon: "glyphicon glyphicon-sort-by-attributes",
      emailSortIcon: "glyphicon glyphicon-sort-by-attributes",
      deal_citySortIcon: "glyphicon glyphicon-sort-by-attributes",
      registeredOnSortIcon: "glyphicon glyphicon-sort-by-attributes",
      show: false,
      direction: "",
      orderBy: ""
    }
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleSelect(limit) {
    this.setState({
      limit: limit
    });
    const postData = {
      page: this.state.currentPage,
      limit: this.state.limit,
      search: this.state.search
    };

    this.props.listPostup(postData, listUrl);
  }

  handleSearch(e) {
    this.setState({ [e.target.name]: e.target.value });
    let searchstring = this.state.search.length > 1 ? this.state.search : "";
    const postData = {
      page: "1",
      limit: this.state.limit,
      search: e.target.value
    };
    if (e.target.value.length !== 0) {
      this.props.listPostup(postData, listUrl);
    } else {
      this.props.listPostup({ page: this.state.currentPage,limit: this.state.limit }, listUrl);
    }
  }

  handleSort = orderBy => e => {
    e.preventDefault();

    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes-alt",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes-alt",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    this.props.listPostup({ orderBy: orderBy, direction: direction,limit: this.state.limit }, listUrl);
  };

  handlePageChange = page => {
    this.setState({
      currentPage: page
    });

    const postData = {
      page: page,
      limit: this.state.limit,
      search: this.state.search ? this.state.search : ""
    };
    this.props.listPostup(postData, listUrl);
  };

  componentWillMount() {
  	isLoading = "true";
    this.handleDismiss();
    this.props.clearAlert();
    this.props.listPostup({ page: this.state.currentPage,limit: this.state.limit }, listUrl);
  }

  componentWillReceiveProps(nextProps) {
  	if (this.props.list !== nextProps.list) {
      if (nextProps.list && nextProps.list.data) {
        const setPageCount =
          nextProps.list.data.total / nextProps.list.data.per_page;
        this.setState({
          list: nextProps.list.data.data,
          totalRecords: nextProps.list.data.total,
          perPage: nextProps.list.data.per_page,
          pageCount: 5
        });
        isLoading = "false";
      }
    }

    if (this.props.deleteStatus !== nextProps.deleteStatus) {
      if (!isEmpty(nextProps.deleteStatus)) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.deleteStatus.message);
        isLoading = "false";
        this.props.listPostup({ page: this.state.currentPage,limit: this.state.limit }, listUrl);
        window.scrollTo(0, 0);
      }
    }

    if (this.props.status !== nextProps.status) {
      if (!isEmpty(nextProps.status)) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.status.message);
        isLoading = "false";
        this.props.listPostup({ page: this.state.currentPage,limit: this.state.limit }, listUrl);
        window.scrollTo(0, 0);
      }
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }

    if (this.props.message !== nextProps.message) {
      if (nextProps.message) {
        this.setState({
          alertMessage: nextProps.message,
          msgType: nextProps.alertType
        });
      }
    }
  }

  render() {
  	const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    let postupRow;
    let listData = this.state.list
      ? this.state.list
      : [];

    if (!isEmpty(listData)) {
      postupRow = listData.map((postup, index) => (
        <tr key={postup.list_id}>
          <td>{postup.title}</td>
          <td>
            <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  {aclUtil.checkACL('EDIT_POSTUP') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/postup/edit/${postup.list_id}`)}><i className="glyphicon glyphicon-pencil"></i> Edit</MenuItem>):("")}
                </DropdownButton>
            </ButtonGroup>
          </td>
        </tr>
      ));
    }else{
      postupRow = <tr><td colSpan='5'>Data Not Found</td></tr>
    }
  	return (
  		<div className="col-lg-12 add-sub-admin">
			{isLoading == "true" ? (
				<div className="loader">
					<p className="loading-message">
						<i>Loading...</i>
					</p>
					<div className="spinner">
					<div className="dot1" />
					<div className="dot2" />
					</div>
				</div>
			) : (
				""
			)}
				<div className="row">
					<div className="col-xs-12">
						<BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context} context={this.context}/>
					</div>
				</div>
				<div className="panel">
          <header className="panel-heading panel-heading-index">
            <div className="row">
              <div className="col-lg-6 col-md-4 col-sm-12">
                <h4>Postup List</h4>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12">
                <FormGroup>
                  <InputGroup>
                    <FormControl type="text" name="search" onKeyUp={this.handleSearch} />
                    <InputGroup.Addon>
                      <Glyphicon glyph="glyphicon glyphicon-search" />
                    </InputGroup.Addon>
                  </InputGroup>
                </FormGroup>
              </div>
              <div className="col-lg-2 col-md-4 col-sm-12">
                {aclUtil.checkACL('ADD_POSTUP') ? (
                  <Button className="addPostup"
                    bsSize="small"
                    bsStyle="success"
                    onClick={() => this.context.router.history.push("/postup/add")}
                  >
                    + Add Postup
                  </Button>)
                  : ("")}
              </div>
            </div>
          </header>
          <div className="panel-body">
          	{this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )
            }
            <div className="row">
              <div className="col-lg-12">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>
                        Postup Title
                      </th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>{postupRow}</tbody>
                </table>
                <div className="text-center">
                	<Pagination
                    total={totalRecords}
                    limit={perPage}
                    pageCount={5}
                    currentPage={currentPage}
                  >
                    {({
                      pages,
                      currentPage,
                      hasNextPage,
                      hasPreviousPage,
                      previousPage,
                      nextPage,
                      totalPages,
                      getPageItemProps
                    }) => (
                      <div className="pagination">
                        <button className="btn btn-default"
                          {...getPageItemProps({
                            pageValue: 1,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          first
                        </button>

                        {hasPreviousPage && (
                          <button className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: previousPage,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {"<"}
                          </button>
                        )}

                        {pages.map(page => {
                          let activePage = null;
                          if (currentPage === page) {
                            activePage = {
                              backgroundColor: "#ccc",
                              color: "#666"
                            };
                          }
                          return (
                            <button className="btn btn-default"
                              key={page}
                              style={activePage}
                              {...getPageItemProps({
                                pageValue: page,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {hasNextPage && (
                          <button className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: nextPage,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {">"}
                          </button>
                        )}

                        <button className="btn btn-default"
                          {...getPageItemProps({
                            pageValue: totalPages,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          last
                        </button>
                      </div>
                    )}
                  </Pagination>
                </div>
              </div>
            </div>
            <div className="clearfix" />
          </div>
        </div>
			</div>
  	)
  }
}

List.propTypes = {
  listPostup: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  list: state.postupReducer.listPostup,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message
});

export default connect(mapStateToProps, {
  listPostup,
  renderAlert,
  clearAlert
}, null, {pure: false})(List);


// WEBPACK FOOTER //
// ./src/app/views/admin/postup/List.js